// src/components/Loading.js
import React, { useState, useEffect } from 'react';
import './index.css'; // Import the CSS file for styling
import shutterfly from "assets/shutterfly.gif";
const Loading = () => {
  const [progress, setProgress] = useState(0);
  const [dots, setDots] = useState('');
  const totalDuration = 7000; // 2 seconds in milliseconds
    const steps = 100; // Number of steps to reach 100%
    const intervalDuration = totalDuration / steps; // Time per step
  // Animate the progress bar
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1;
      });
    }, intervalDuration); // Adjust the speed of the progress bar here

    return () => clearInterval(interval);
  }, []);

  // Animate the "Loading...." text
  useEffect(() => {
    const dotInterval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? '' : prev + '.'));
    }, 500); // Adjust the speed of the dot animation here

    return () => clearInterval(dotInterval);
  }, []);

  return (
    <div className="loader-modal" id="loader">
      <div className="loadersWrapper">
        <div className="loader">
          <img
            src={shutterfly}
            alt="Loading"
            className="loader-icon"
          />
          <p className="shutterfly-text"><strong>SHUTTER FLY</strong></p>
          <p className="loading-text">Loading{dots}</p> {/* Dynamic "Loading...." text */}
        </div>
        <div className="loadingBarContainer">
          <div className="loadingBar" style={{ width: `${progress}%` }}></div>
        </div>
      </div>
    </div>
  );
};

export default Loading;